import { render, staticRenderFns } from "./PrivateDiscussionLinkedin.vue?vue&type=template&id=22f83258&"
import script from "./PrivateDiscussionLinkedin.vue?vue&type=script&lang=js&"
export * from "./PrivateDiscussionLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports